<template>
  <div
    class="w-full px-[14px] py-2.5 rounded-sm bg-gray-800/5 flex items-center font-secondary text-[14px] text-gray-800"
  >
    <ThumbnailIcon
      :image-url="imageUrl"
      :type="props.file.type"
      :icon-size="36"
      class="min-w-9 max-w-9 h-9 mr-2.5"
    />
    <div class="w-full" v-truncate>
      <div data-truncate-target class="font-primary font-medium text-[15px]">
        {{ props.file.metadata.originalFilename }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { File } from '@/shared/graphql/router/graphql'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { ThumbnailIcon } from '@dacr/ui'
import { computed } from 'vue'

const props = defineProps<{
  file: File
}>()

const imageUrl = computed(() =>
  props.file.asset?.previewImageUrl
    ? applyAuthorizationToken(props.file.asset.previewImageUrl)
    : undefined
)
</script>
